export type AudioBusId = 'music' | 'ambient' | 'sfx' | 'ui' | 'voice';

export const AUDIO_BUS_IDS: readonly AudioBusId[] = [
  'music',
  'ambient',
  'sfx',
  'ui',
  'voice',
];

export type AudioBusVolumes = Record<AudioBusId, number>;
